import { List, Map, RecordOf } from '@opengov/compose-app/immutable';
import { CalendarUnit, mapColumnToRecord, StorageReportColumnRecord } from './reportColumns';
import { ColumnFilterRecord } from './reportFilters';
export var SortDirection;

(function (SortDirection) {
  SortDirection["ASC"] = "ASC";
  SortDirection["DESC"] = "DESC";
  SortDirection["None"] = "None";
})(SortDirection || (SortDirection = {}));

export var ReportTableTabs;

(function (ReportTableTabs) {
  ReportTableTabs["Summary"] = "summary";
  ReportTableTabs["Details"] = "details";
})(ReportTableTabs || (ReportTableTabs = {}));

export var EReportTargetComparisonOperators;

(function (EReportTargetComparisonOperators) {
  EReportTargetComparisonOperators["greaterThan"] = "greaterThan";
  EReportTargetComparisonOperators["greaterThanOrEqualTo"] = "greaterThanOrEqualTo";
  EReportTargetComparisonOperators["lessThan"] = "lessThan";
  EReportTargetComparisonOperators["lessThanOrEqualTo"] = "lessThanOrEqualTo";
  EReportTargetComparisonOperators["equalTo"] = "equalTo";
  EReportTargetComparisonOperators["notEqualTo"] = "notEqualTo";
})(EReportTargetComparisonOperators || (EReportTargetComparisonOperators = {}));

export var EReportTargetValueTypes;

(function (EReportTargetValueTypes) {
  EReportTargetValueTypes["currency"] = "currency";
  EReportTargetValueTypes["number"] = "number";
  EReportTargetValueTypes["percent"] = "percent";
})(EReportTargetValueTypes || (EReportTargetValueTypes = {}));

export var OrganizedByColumnType;

(function (OrganizedByColumnType) {
  OrganizedByColumnType["Date"] = "date";
  OrganizedByColumnType["Text"] = "text";
  OrganizedByColumnType["Period"] = "period";
})(OrganizedByColumnType || (OrganizedByColumnType = {}));

export var OrganizedByRecord = RecordOf({
  columnName: '',
  columnType: OrganizedByColumnType.Date,
  selection: CalendarUnit.FiscalYear
});
export var ChartType;

(function (ChartType) {
  ChartType["VerticalBar"] = "bar";
  ChartType["HorizontalBar"] = "horizontal_bar";
  ChartType["Line"] = "line";
  ChartType["Pie"] = "pie";
})(ChartType || (ChartType = {}));

export var reportConfigurationDetailTableQueryRecord = RecordOf({
  columns: List(),
  sortColumn: '',
  sortDirection: SortDirection.ASC,
  paginationLimit: 25,
  paginationOffset: 0,
  searchTableQuery: '',
  filter: List(),
  searchTableQueryColumn: StorageReportColumnRecord()
});
export var ReportConfigurationDetailTableQueryRecord = function ReportConfigurationDetailTableQueryRecord(rs) {
  return !rs ? reportConfigurationDetailTableQueryRecord() : reportConfigurationDetailTableQueryRecord(rs).set('columns', rs.columns ? List(rs.columns.map(mapColumnToRecord)) : List()).set('filter', rs.filter ? List(rs.filter.map(ColumnFilterRecord)) : List()).set('searchTableQueryColumn', rs.searchTableQueryColumn ? mapColumnToRecord(rs.searchTableQueryColumn) : StorageReportColumnRecord());
};
export var ReportControlType;

(function (ReportControlType) {
  ReportControlType["By"] = "by";
  ReportControlType["Show"] = "show";
  ReportControlType["Categorize"] = "categorize";
})(ReportControlType || (ReportControlType = {}));

export var HiddenControlColumnsRecord = RecordOf({
  type: null,
  columnName: ''
});
var reportConfigurationVisualizationQueryRecord = RecordOf({
  chartType: ChartType.VerticalBar,
  categorizedByColumnName: '',
  categorizedByColumn: StorageReportColumnRecord(),
  hiddenControls: List(),
  showColumnAsPercentOfTotal: false,
  showColumnName: '',
  showColumn: StorageReportColumnRecord(),
  filter: List(),
  organizedBy: OrganizedByRecord()
});
export var ReportConfigurationVisualizationQueryRecord = function ReportConfigurationVisualizationQueryRecord(rs) {
  return !rs ? reportConfigurationVisualizationQueryRecord() : reportConfigurationVisualizationQueryRecord(rs).set('hiddenControls', rs.hiddenControls ? List(rs.hiddenControls.map(HiddenControlColumnsRecord)) : List()).set('showColumn', rs.showColumn ? mapColumnToRecord(rs.showColumn) : StorageReportColumnRecord()).set('categorizedByColumn', rs.categorizedByColumn ? mapColumnToRecord(rs.categorizedByColumn) : StorageReportColumnRecord()).set('filter', rs.filter ? List(rs.filter.map(ColumnFilterRecord)) : List()).set('organizedBy', rs.organizedBy ? OrganizedByRecord(rs.organizedBy) : OrganizedByRecord());
};
export var createColorMapFromObject = function createColorMapFromObject(colors) {
  var valueMap = [];
  Object.keys(colors).forEach(function (categoryString) {
    if (typeof colors[categoryString] === 'object') valueMap.push([categoryString, SingleColorRecord(colors[categoryString])]);
  });
  return Map(valueMap);
};
export var SingleColorRecord = function SingleColorRecord(rs) {
  return !rs ? singleColorRecord() : singleColorRecord(rs);
};
var singleColorRecord = RecordOf({
  type: 'custom',
  hexValue: ''
});
var reportConfigurationPresentationRecord = RecordOf({
  columnNames: List(),
  colors: Map(),
  entityFiscalYearStartMonth: 1,
  reportTableActiveTab: ReportTableTabs.Summary
});
export var ReportConfigurationPresentationRecord = function ReportConfigurationPresentationRecord(rs) {
  var colors;

  if (rs && rs.colors) {
    colors = Map.isMap(rs.colors) ? rs.colors : createColorMapFromObject(rs.colors);
  }

  return !rs ? reportConfigurationPresentationRecord() : reportConfigurationPresentationRecord(rs).set('colors', colors ? colors : createColorMapFromObject()).set('columnNames', rs.columnNames ? List(rs.columnNames.map(ColumnAliasRecord)) : List());
};
export var ColumnAliasRecord = RecordOf({
  columnIndex: 0,
  originalName: '',
  displayName: ''
});
export var reportConfigurationLayersRecord = RecordOf({
  target: null
});
export var ReportConfigurationLayersRecord = function ReportConfigurationLayersRecord(rs) {
  return !rs ? reportConfigurationLayersRecord() : reportConfigurationLayersRecord(rs).set('target', ReportTargetRecord(rs.target));
};
export var reportTargetRecord = RecordOf({
  conditions: List(),
  elseStatus: null
});
export var ReportTargetRecord = function ReportTargetRecord(rs) {
  return !rs ? reportTargetRecord() : reportTargetRecord(rs).set('conditions', rs.conditions ? List(rs.conditions.map(ReportTargetConditionRecord)) : List()).set('elseStatus', ReportTargetStatusRecord(rs.elseStatus));
};
export var reportTargetConditionRecord = RecordOf({
  operator: null,
  value: null,
  status: null
});
export var ReportTargetConditionRecord = function ReportTargetConditionRecord(rs) {
  return !rs ? reportTargetConditionRecord() : reportTargetConditionRecord(rs).set('status', ReportTargetStatusRecord(rs.status)).set('value', ReportTargetValue(rs.value));
};
export var ReportTargetValue = RecordOf({
  valueType: null,
  text: null
});
export var ReportTargetStatusRecord = RecordOf({
  text: null
});
var reportConfigurationPayloadRecord = RecordOf({
  reportId: null,
  viewId: null,
  visualizationQuery: ReportConfigurationVisualizationQueryRecord(),
  detailTableQuery: ReportConfigurationDetailTableQueryRecord(),
  presentationConfiguration: ReportConfigurationPresentationRecord(),
  layers: ReportConfigurationLayersRecord()
});
export var ReportConfigurationPayloadRecord = function ReportConfigurationPayloadRecord(rs) {
  return !rs ? reportConfigurationPayloadRecord() : reportConfigurationPayloadRecord(rs).set('visualizationQuery', !rs.visualizationQuery ? ReportConfigurationVisualizationQueryRecord() : ReportConfigurationVisualizationQueryRecord(rs.visualizationQuery)).set('detailTableQuery', !rs.detailTableQuery ? ReportConfigurationDetailTableQueryRecord() : ReportConfigurationDetailTableQueryRecord(rs.detailTableQuery)).set('presentationConfiguration', !rs.presentationConfiguration ? ReportConfigurationPresentationRecord() : ReportConfigurationPresentationRecord(rs.presentationConfiguration)).set('layers', !rs.layers ? ReportConfigurationLayersRecord() : ReportConfigurationLayersRecord(rs.layers));
};
var reportConfigurationRecord = RecordOf({
  id: null,
  reportId: null,
  viewId: null,
  visualizationQuery: ReportConfigurationVisualizationQueryRecord(),
  detailTableQuery: ReportConfigurationDetailTableQueryRecord(),
  presentationConfiguration: ReportConfigurationPresentationRecord(),
  layers: ReportConfigurationLayersRecord()
});
export var ReportConfigurationRecord = function ReportConfigurationRecord(rs) {
  return !rs ? reportConfigurationRecord() : reportConfigurationRecord(rs).set('visualizationQuery', !rs.visualizationQuery ? ReportConfigurationVisualizationQueryRecord() : ReportConfigurationVisualizationQueryRecord(rs.visualizationQuery)).set('detailTableQuery', !rs.detailTableQuery ? ReportConfigurationDetailTableQueryRecord() : ReportConfigurationDetailTableQueryRecord(rs.detailTableQuery)).set('presentationConfiguration', !rs.presentationConfiguration ? ReportConfigurationPresentationRecord() : ReportConfigurationPresentationRecord(rs.presentationConfiguration)).set('layers', !rs.layers ? ReportConfigurationLayersRecord() : ReportConfigurationLayersRecord(rs.layers));
};